Array.prototype.elementAt = function(index) {
  return this[index];
};

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  return new Promise((resolve, reject) => {
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);
    if (!successful) {
      throw Error("Copy was failed");
    }
  });
}

export const utilityMixin = {
  methods: {
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        return fallbackCopyTextToClipboard(text);
      }
      return navigator.clipboard.writeText(text);
    },
    debounce(func, wait) {
      var lastCallDate;
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var callNow =
          !lastCallDate || lastCallDate + wait < new Date().getTime();
        if (callNow) {
          lastCallDate = new Date().getTime();
          func.apply(context, args);
        } else {
          if (timeout) {
            clearTimeout(timeout);
          }
          timeout = setTimeout(() => func.apply(context, args), wait);
        }
      };
    },
    currentTimestamp() {
      return Math.round(new Date().getTime() / 1000);
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    timeFormatter(date, divider = ":") {
      return (
        ("0" + date.getHours()).slice(-2) +
        divider +
        ("0" + date.getMinutes()).slice(-2)
      );
    },
    dateFormatter(date, divider = ".", usFormat = false) {
      return (
        (usFormat ? date.getFullYear() : ("0" + date.getDate()).slice(-2)) +
        divider +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        divider +
        (usFormat ? ("0" + date.getDate()).slice(-2) : date.getFullYear())
      );
    },
    rangeFormatter(open, close) {
      const openDate = new Date((open || 0) * 1000);
      const endDate = new Date((close || 0) * 1000);
      return this.dateFormatter(openDate) + " - " + this.dateFormatter(endDate);
    },
    EvenOddIterator(base, even) {
      class EvenOddIterator {
        constructor(base, even) {
          this.index = even ? 0 : 1;
          this.base = base;
        }

        [Symbol.iterator]() {
          return {
            next: function() {
              if (this.index < this.base.length) {
                const currentIndex = this.index;
                this.index += 2;
                return {
                  value: this.base.elementAt(currentIndex),
                  done: false
                };
              } else {
                return { done: true };
              }
            }.bind(this)
          };
        }
      }
      return new EvenOddIterator(base, even);
    },
    resolvedPromise(promise, defValue) {
      return promise.then(v => v, () => defValue);
    },
    isSmallerThanOrEqual(width) {
      return window.innerWidth <= width;
    },
    isBiggerThanOrEqual(width) {
      return window.innerWidth >= width;
    },
    readURL(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onloadend = function(e) {
          resolve(e.target.result);
        };

        reader.readAsDataURL(file);
      });
    },

    // fetch API
    jsonp(element, url, callback) {
      var callbackName = "jsonp_callback_" + Math.round(100000 * Math.random());
      var script = document.createElement("script");
      script.src =
        url + (url.indexOf("?") >= 0 ? "&" : "?") + "callback=" + callbackName;
      window[callbackName] = function(data) {
        delete window[callbackName];
        element.removeChild(script);
        callback(data);
      };
      element.appendChild(script);
    },
    runPreflightRequest(url, options, origin) {
      return fetch(url, {
        method: "OPTIONS",
        headers: {
          "Access-Control-Request-Method": "GET",
          "Access-Control-Request-Headers": Object.keys(options.headers || {}),
          Origin: origin || "*"
        }
      });
    },
    getVkCountries(code) {
      const url =
        "https://api.vk.com/method/database.getCountries?access_token=3e680e403e680e403e680e40663e3093b233e683e680e4065a8ee901b0a025216fae62e&lang=ru&code=" +
        code;
      const options = {
        headers: {
          "Content-Type": "text/plain"
        }
      };
      return fetch(url, options).then(resp => resp.json());
    },
    getVkRegions(countryID, query, count) {
      const url = `https://api.vk.com/method/database.getRegions?access_token=3e680e403e680e403e680e40663e3093b233e683e680e4065a8ee901b0a025216fae62e&lang=ru&q=${query}&count=${count ||
        10}&country_id=${countryID}`;
      const options = {
        headers: {
          "Content-Type": "text/plain"
        }
      };
      return fetch(url, options).then(resp => resp.json());
    },
    getRESTCountries(fields) {
      const url =
        "https://restcountries.eu/rest/v2/all?fields=" +
        (fields || ["translations", "alpha2Code"]).join(";");
      return fetch(url).then(resp => resp.json());
    },
    reverseGeocode(location) {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${
        location[1]
      },${
        location[0]
      }.json?access_token=pk.eyJ1Ijoiay1vLWQtZS1uIiwiYSI6ImNqbmc0aGl4ejBybnYzcXA3dHZjemRsdzMifQ.u_NpqbGnlBgQSY6hq_jEwQ&language=ru`;
      return fetch(url, { cache: "force-cache" })
        .then(resp => resp.json())
        .then(json => {
          if (
            !(
              json.features &&
              Array.isArray(json.features) &&
              json.features.length > 0
            )
          )
            return null;
          const address =
            json.features.find(val => {
              if (!val.place_type && Array.isArray(val.place_type))
                return false;
              return val.place_type.includes("address");
            }) || json.features[0];

          return address.place_name;
        })
        .catch(e => console.error("Location reverse geocoding failed", e));
    },
    geocode(placeName, countries, limit = 1) {
      return this.places(placeName, countries, limit).then(elements => {
        if (elements) {
          return elements[0].geometry.coordinates;
        }
      });
    },
    places(placeName, countries, limit = 1) {
      const countriesParam =
        countries && countries.length
          ? "&countries=" + countries.join(",")
          : "";
      const url =
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${placeName}.json?types=place&limit=${limit}&access_token=pk.eyJ1Ijoiay1vLWQtZS1uIiwiYSI6ImNqbmc0aGl4ejBybnYzcXA3dHZjemRsdzMifQ.u_NpqbGnlBgQSY6hq_jEwQ&language=ru` +
        countriesParam;
      return fetch(url, { cache: "force-cache" })
        .then(resp => resp.json())
        .then(json => {
          if (
            !(
              json.features &&
              Array.isArray(json.features) &&
              json.features.length > 0
            )
          )
            return null;

          return json.features;
        })
        .catch(e => console.error("Location geocoding failed", e));
    },
    queryParams(params) {
      return Object.keys(params)
        .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");
    },

    // validators
    addressValidator(newValue) {
      const result = !!(
        newValue &&
        newValue.countryCode &&
        newValue.administrativeArea &&
        newValue.administrativeAreaCode &&
        newValue.localityCode
      );
      return result;
    },
    teamInfoValidator(newValue) {
      if (!newValue) return true;
      if (newValue.colors) {
        return newValue.colors.first && newValue.colors.second;
      }
      return true;
    },

    // models, TODO: Remove
    playerPosition(raw) {
      switch (raw) {
        case 1:
          return "Goalkeeper";
        case 2:
          return "Defender";
        case 3:
          return "Midfielder";
        case 4:
          return "Striker";
        default:
          return "Universal";
      }
    },
    genderTitle(gender) {
      switch (gender) {
        case 0:
          return "Male";
        case 1:
          return "Female";
        default:
          return "";
      }
    }
  }
};
